import i18n from 'live/services/i18n'

import en_us from './i18n/en_us'
import pt_br from './i18n/pt_br'

try {
    const locale = Live.settings && Live.settings.locale ? Live.settings.locale : 'pt_br'
    const localeFiles = {
        pt_br,
        en_us
    }
    i18n.add(localeFiles[locale])
} catch (e) {
    console.error(e)
}
